import { IonButton } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useInvoices } from '../../../hooks/useInvoices'
import { InvoiceList } from './InvoiceList'

export const PaidInvoices = () => {
	const { t } = useTranslation('pages_invoices')

	const { invoices, fetchOldInvoices } = useInvoices()

	return (
		<div>
			<div>
				<IonButton onClick={() => fetchOldInvoices()} className='mb-4' size='small'>
					{t('fetchOldContractsHeader')}
				</IonButton>
			</div>
			<InvoiceList invoices={invoices.paid} />
			<div className='w-3/5 mx-auto mt-6'>
				<span className='disclaimer text-text-grey-200 dark:text-text-grey-100 text-center block'>
					{t('disclaimer')}
				</span>
			</div>
		</div>
	)
}
